import { z } from 'zod';
import { Questionnaire } from './Questionnaire';

export const questionnaireListExample = z.array(Questionnaire).parse([
  // 50個分のデータを作る。createdAt, updatedAt, expiredAt は1日ずつずらす。
  ...Array.from({ length: 50 }, (_, i) => ({
    id: `questionnaire-${i}`,
    locationId: 'location-0',
    name: `アンケート ${i}`,
    description: `アンケート ${i} の説明`,
    numberOfRespondents: 0,
    createdAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
    updatedAt: new Date(Date.UTC(2021, 1, 1 + i, 0, 0, 0, 0)).toISOString(),
    expiredAt: new Date(Date.UTC(2021, 1, 1 + i + 1, 0, 0, 0, 0)).toISOString(),
  })),
]);
